/** Maps API language codes to keys under `language.*` in locale files (aligned with sidebar). */
const CODE_TO_I18N_KEY = {
    en: 'language.english',
    nl: 'language.dutch',
    de: 'language.german'
};
export function getTranslatedLanguageLabel(t, lang) {
    const base = String(lang.code ?? '')
        .split('-')[0]
        .toLowerCase();
    const key = CODE_TO_I18N_KEY[base];
    if (key)
        return t(key);
    return lang.name ?? '';
}
